import { Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList } from '@angular/core';
import { PickerChoiceDirective } from '../multi-images-picker/directives/picker-choice.directive';

@Component({
  selector: 'app-multi-images-selectable-list',
  templateUrl: './images-selectable-list.component.html',
  styleUrls: [ './images-selectable-list.component.sass' ]
})
export class ImagesSelectableListComponent<T> implements OnInit {

  @Input() enableSelect = false;
  @Input() compact = false;
  @Input() columns = 3;
  @Input() rowHeight = '2:1';
  @Input() selected: T;
  @Output() selectedChange = new EventEmitter<T>();
  @ContentChildren(PickerChoiceDirective) choices: QueryList<PickerChoiceDirective<T>>;

  constructor() { }

  ngOnInit(): void {
  }

  select(value: PickerChoiceDirective<T>) {
    if (!this.enableSelect) {
      return;
    }
    this.selected = value.appPickerChoice;
    this.selectedChange.emit(this.selected);
  }
}
